export const GET_SESSION_TYPES = "GET_SESSION_TYPES"
export const GET_SESSION_TYPES_FAIL = "GET_SESSION_TYPES_FAIL"
export const GET_SESSION_TYPES_SUCCESS = "GET_SESSION_TYPES_SUCCESS"

export const ADD_NEW_SESSION_TYPE = "ADD_NEW_SESSION_TYPE"
export const ADD_SESSION_TYPE_SUCCESS = "ADD_SESSION_TYPE_SUCCESS"
export const ADD_SESSION_TYPE_FAIL = "ADD_SESSION_TYPE_FAIL"

export const UPDATE_SESSION_TYPE = "UPDATE_SESSION_TYPE"
export const UPDATE_SESSION_TYPE_SUCCESS = "UPDATE_SESSION_TYPE_SUCCESS"
export const UPDATE_SESSION_TYPE_FAIL = "UPDATE_SESSION_TYPE_FAIL"

export const DELETE_SESSION_TYPE = "DELETE_SESSION_TYPE"
export const DELETE_SESSION_TYPE_SUCCESS = "DELETE_SESSION_TYPE_SUCCESS"
export const DELETE_SESSION_TYPE_FAIL = "DELETE_SESSION_TYPE_FAIL"





